import { render, staticRenderFns } from "./Complex.vue?vue&type=template&id=b12e1976&scoped=true&"
import script from "./Complex.vue?vue&type=script&lang=js&"
export * from "./Complex.vue?vue&type=script&lang=js&"
import style0 from "./Complex.vue?vue&type=style&index=0&id=b12e1976&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12e1976",
  null
  
)

export default component.exports